import { Briefcase, Clock, MapPin } from 'lucide-react'
import type { I18nKeys } from '@/shared/core/hooks/use-translation/use-translation.ts'
import { AiBanner } from '@/teams/portfolio/components/section/home-section/ai-indicator/ai-banner/ai-banner.tsx'
import { InfoCard } from '@/teams/portfolio/components/section/home-section/ai-indicator/info-card/info-card.tsx'
import { TechStack } from '@/teams/portfolio/components/section/home-section/ai-indicator/tech-stack/tech-stack.tsx'
import '@/teams/portfolio/components/section/home-section/ai-indicator/ai-indicator.scss'
import { useFeatureFlag } from '@/shared/core/hooks/use-feature-flag/use-feature-flag.ts'

export function AiIndicator() {
	const showAiIndicator = useFeatureFlag(
		'portfolio.section.aiIndicator.enabled',
	)
	if (!showAiIndicator) {
		return null
	}

	return (
		<div className='ai-indicator' data-testid='ai-indicator-section'>
			<AiBanner />
			<div className='ai-indicator__info-row'>
				<InfoCard
					icon={MapPin}
					titleKey={'portfolio.section.aiIndicator.info.location' as I18nKeys}
					valueKey={
						'portfolio.section.aiIndicator.info.locationSubtext' as I18nKeys
					}
				/>
				<InfoCard
					icon={Clock}
					titleKey={'portfolio.section.aiIndicator.info.experience' as I18nKeys}
					valueKey={
						'portfolio.section.aiIndicator.info.experienceSubtext' as I18nKeys
					}
				/>
				<InfoCard
					icon={Briefcase}
					titleKey={'portfolio.section.aiIndicator.info.role' as I18nKeys}
					valueKey={
						'portfolio.section.aiIndicator.info.roleSubtext' as I18nKeys
					}
				/>
			</div>
			<TechStack />
		</div>
	)
}
